import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MedicineService } from 'src/core/services/medicine.service';
import { toPackageTypeApiPayload } from 'src/core/utils/package-type-payload';
import { readSageItemCode } from 'src/core/utils/sage-item-code';
import { packageTypeSelectedValidator } from 'src/core/validators/package-type';
import { EditMedicineDosagePackageTypePayload, MedicineDosagePackageType, PackageType } from 'src/interfaces/medicine';

export interface DialogData {
  title: string;
  message: string;
  medicineId: number;
  medicineDosageTypeId: number;
  packageTypes: PackageType[];
  medicineDosagePackageType: MedicineDosagePackageType;
}
@Component({
    selector: 'core-medicine-dosage-package-type-edit-dialog',
    templateUrl: './medicine-dosage-package-type-edit-dialog.component.html',
    styleUrls: ['./medicine-dosage-package-type-edit-dialog.component.scss'],
    standalone: false
})
export class MedicineDosagePackageTypeEditDialogComponent implements OnInit {

  medicineDosagePackageType: MedicineDosagePackageType | null = null;

  medicineDosagePackageTypeForm = this._formBuilder.group({
    packageType: ['', packageTypeSelectedValidator],
    containedQuantity: ['', Validators.compose([Validators.required, Validators.min(1)])],
    unitsPerPack: [1, Validators.compose([Validators.required, Validators.min(1)])],
    minOrderQty: ['', Validators.min(1)],
    labelName: ['', Validators.compose([Validators.required, Validators.maxLength(25)])],
    price: ['', Validators.compose([Validators.required, Validators.min(1)])],
    sageItemCode: [''],
  })

  labelNameExceeds25Chars: boolean = false;

  constructor(
    public _dialogRef: MatDialogRef<MedicineDosagePackageTypeEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _formBuilder: UntypedFormBuilder,
    private _medicineService: MedicineService
  ) { }

  ngOnInit(): void {

    this.medicineDosagePackageType = this.data.medicineDosagePackageType;

    const selectedPackageType: PackageType | null =
      this.medicineDosagePackageType?.package_type ??
      this.data.packageTypes.find(type => type.id === this.medicineDosagePackageType?.package_type_id) ??
      null;

    // update form value 
    this.medicineDosagePackageTypeForm.patchValue({
      packageType: selectedPackageType,
      containedQuantity: this.medicineDosagePackageType.contained_quantity,
      unitsPerPack: this.medicineDosagePackageType.units_per_pack != null ? this.medicineDosagePackageType.units_per_pack : 1,
      minOrderQty: this.medicineDosagePackageType.min_order_qty != null ? this.medicineDosagePackageType.min_order_qty : '',
      labelName: this.medicineDosagePackageType.label_name,
      price: this.medicineDosagePackageType.price,
      sageItemCode: readSageItemCode(this.medicineDosagePackageType),
    })


    this.medicineDosagePackageTypeForm.controls['labelName']
      .valueChanges.subscribe((value) => {
        this.labelNameExceeds25Chars = value.length > 25;
      })
  }

  async save() {

    if (!this.medicineDosagePackageType) return;
    const payload: EditMedicineDosagePackageTypePayload = toPackageTypeApiPayload(
      this.medicineDosagePackageTypeForm.getRawValue()
    );

    const success: boolean = await this._medicineService
      .editMedicineDosagePackageType(
        this.data.medicineId,
        this.data.medicineDosageTypeId,
        this.medicineDosagePackageType.id,
        payload
      );

    if (success) {
      this._dialogRef.close({
        id: this.medicineDosagePackageType.id,
        sageItemCode: payload.sage_item_code,
      });
    }
  }

}
